import { NewBrandsPageData, LandingPageData, LandingPageHeroType, BrandVideoData } from '@/shared/types/landing-page';
import { STATIC_FILE_URL } from '@/shared/constants';
import { FAQType } from '../types/subscription';

export const EXISTING_BRAND_PAGE_DATA: NewBrandsPageData = {
  hero: {
    title: 'Scale your brand & save up to 50% with Pietra',
    subtitle:
      "Pietra's members-only products and services gives brands competitive pricing on core software and services.",
    titleColor: '#fff',
    bgColor: 'radial-gradient(126.01% 147.85% at 4.11% 0%, #FF5C3C 0%, #F2C296 100%)',
    preTitleImg: '/svg/pietra-oval-logo.svg',
    btnText: 'Create Pietra account',
    spotlightItems: [
      {
        image: `${STATIC_FILE_URL}/b01570be1f32c7020186e6dd44e0941b.png`,
        title: 'Easier Payments',
        description:
          'Put all of your invoices in one place and get a 0% service fee when you connect your existing suppliers.',
      },
      {
        image: `${STATIC_FILE_URL}/7a2d77cf1f30532a865aad2b7b34b7be.png`,
        title: 'Low Cost Fulfillment',
        description:
          'Get free shipping from your factory to a Pietra Fulfillment Center and get pick and pack fees starting at $1.50/order.',
      },
      {
        image: `${STATIC_FILE_URL}/a26b83630e3784a2e1617f86b4285b6e.png`,
        title: 'Easier Asset Management',
        description: 'Stop sending PDFs over email. Manage all of your production assets in one place.',
      },
    ],
  },
  highlightCards: {
    title: 'Ways to use Pietra',
    cards: [
      {
        img: `${STATIC_FILE_URL}/251fe554a8803390dba13e876f2bd60e.png`,
        title: 'Launch new product lines',
      },
      {
        img: `${STATIC_FILE_URL}/7746a93b29421c7efbfbe1003e765e13.png`,
        title: 'Streamline your fulfillment',
      },
      {
        img: `${STATIC_FILE_URL}/77d3276014c4e4e129cc59c7f06b35c2.png`,
        title: 'Scale & manage your operations',
      },
    ],
  },
  sectionsTitle: 'For the smartest E-commerce operators',
  sections: [
    {
      id: 'e-commerce',
      image: `${STATIC_FILE_URL}/78e60a083702fa85b5ab48300900d26c.png`,
      title: 'Centralize your communications & invoices.',
      description: null,
      buttonText: 'Learn more',
    },
    {
      id: 'sourcing',
      image: `${STATIC_FILE_URL}/42c7173913f8e96e26b589e80dcac5ca.png`,
      title: 'Expand your product offering without expanding your team.',
      description:
        'Source from trusted, vetted and trained manufacturers, to take the headache out of production. Work with the top suppliers that have worked with Nike, Gucci, Starbucks, and more to expand your product and avoid handling all the logistics yourself.',
      buttonText: 'Learn more',
    },
    {
      id: 'fulfillment',
      image: `${STATIC_FILE_URL}/7ec727838c9a4bcff9b70791a57f17c2.png`,
      title: '$1.50 order fulfillment & 2-Day shipping for all.',
      description:
        "Use Pietra's Fulfillment Center to ship orders to customers around the world. Optimized for product drops and growing e-commerce businesses.",
      buttonText: 'Learn more',
    },
    {
      id: 'education',
      image: `${STATIC_FILE_URL}/f1fc99ccd67681d83b1c975dd89b4bc8.png`,
      title: 'Get access to experts when you need them.',
      description:
        'Pietra allows you to book 1:1 time with production specialists, fulfillment wizards, and e-commerce professionals to help you scale up your business. Never feel like you have to figure it all out yourself. We got you.',
      buttonText: 'Learn more',
    },
  ],
};

export const NEW_BRAND_PAGE_DATA: LandingPageData = {
  hero: {
    type: LandingPageHeroType.SPOTLIGHT,
    showPietraLogo: false,
    showBrandLogo: false,
    showPlatformLogo: true,
    hideArrowRightIcon: true,
    title: ['Juggling it all? Make e-commerce simple with Pietra'],
    subtitle: 'The ultimate all-in-one platform to launch and scale your e-commerce brand—grow to $50M and beyond.',
    button: {
      text: [{ text: 'Create Free Account' }],
    },
    spotlightItems: [
      {
        image: `${STATIC_FILE_URL}/671616148c9b2b3ba23497ea34c90217.png`,
        title: '',
      },
      {
        image: `${STATIC_FILE_URL}/b28db263d637eeffd81f3cf28871fa8f.png`,
        title: '',
      },
      {
        image: `${STATIC_FILE_URL}/0cabddc267a295c5d230bda0fcc74323.png`,
        title: '',
      },
      {
        image: `${STATIC_FILE_URL}/441edb73e1d10e28fe31e5f095ba6f71.png`,
        title: '',
      },
    ],
  },
  features: {
    title: 'Pietra makes it easy to start a new brand',
    features: [
      {
        image: `${STATIC_FILE_URL}/7840880a71c640c096cf92ec7e67e31b.png`,
        title: 'Pietra has put all the best factories in one place for you to work with.',
        description: "You don't have the travel and vet them yourself. We've already done that for you.",
        buttonText: 'Get started for free',
      },
      {
        image: `${STATIC_FILE_URL}/50d1f95022440348c82a9ac9dcaffbfe.png`,
        title: 'Pietra gives you a way to ship orders to customers cheaper and faster. ',
        description:
          "That's right. Pietra offers small business owners the most affordable 3PL in the USA. If you can find better prices, we'll match it!",
        buttonText: 'Get started for free',
      },
      {
        image: `${STATIC_FILE_URL}/f14ba1d0c591acfa469ab4916fdf5531.png`,
        title: 'Connect your existing website or set up a Pietra Shop.',
        description:
          'Pietra connects to many website providers like Shopify, Wix, BigCommerce, and also provides a way to create a storefront.',
        buttonText: 'Get started for free',
      },
      {
        image: `${STATIC_FILE_URL}/bc5a174dce1d378c83b4c655e7c3cb29.png`,
        title: 'Get marketing software to help sell your products after you launch.',
        description: 'Your Pietra membership gives you access to 5+ marketing tools to grow your sales.',
        buttonText: 'Get started for free',
      },
    ],
  },
};

export const NEW_BRAND_PAGE_DATA_V2: NewBrandsPageData = {
  hero: {
    title: 'A new way to dropship with Pietra',
    subtitle: 'The ease of traditional dropshipping but with custom products and domestic shipping',
    bgColor: 'radial-gradient(126.01% 147.85% at 4.11% 0%, #3C44FF 0%, #754FC6 100%)',
    titleColor: '#fff',
    btnText: 'Create Free Pietra Account',
    spotlightItems: [
      {
        image: `${STATIC_FILE_URL}/e94f5fabf0b172ef10c5ef12eda1fc63.png`,
        title: '170,000+ customizable products',
        description: 'Find a product, customize it, and stand out so nobody can copy your winning products. ',
      },
      {
        image: `${STATIC_FILE_URL}/3140ba3a9b4ab38cccbcf4372e4165a6.png`,
        title: 'Deliver in days, not weeks',
        description:
          'Work with a factory to ship products to Pietra. We store and ship your product from a US-based warehouse.',
      },
      {
        image: `${STATIC_FILE_URL}/4ac6a1e183c9296b850040bf1515834c.png`,
        title: 'Make more money',
        description: 'Get the best price with low minimums and charge a premium for your custom branded products.',
      },
    ],
    showHeroItem: true,
  },
  highlightCards: {
    title: 'A better way to dropship',
    cards: [
      {
        img: `${STATIC_FILE_URL}/4b8649480e9ad816ddc61507e3dac4aa.png`,
        title: 'Vetted products that people love',
        bgColor: 'radial-gradient(126.01% 147.85% at 4.11% 0%, #3C44FF 0%, #754FC6 100%)',
      },
      {
        img: `${STATIC_FILE_URL}/3140ba3a9b4ab38cccbcf4372e4165a6.png`,
        title: "Use Pietra's US-based warehouse",
        bgColor: 'radial-gradient(126.01% 147.85% at 4.11% 0%, #3C44FF 0%, #754FC6 100%)',
      },
      {
        img: `${STATIC_FILE_URL}/91ca3aef22c17981e8405dc0e3f892b8.png`,
        title: 'Connect to your Shopify store',
        bgColor: 'radial-gradient(126.01% 147.85% at 4.11% 0%, #3C44FF 0%, #754FC6 100%)',
      },
    ],
  },
  sectionsTitle: 'Trusted by 300,000+ entrepreneurs',
  sections: [
    {
      id: 'sourcing',
      image: `${STATIC_FILE_URL}/a25a6a8356a41d84f6d791e9b3cf7dba.png`,
      title: 'Design bestselling products with AI',
      description:
        "Dream up any product and endlessly customize it. When you're ready, send to Pietra's 1300+ factory network with one click.",
      buttonText: 'Create Free Account',
    },
    {
      id: 'fulfillment',
      image: `${STATIC_FILE_URL}/54792b1b0a320cbd9a4b738113f58738.png`,
      title: 'Source low cost custom packaging to stand out.',
      description:
        "Design packaging and send it to Pietra's warehouse to package your orders and stand out from the crowd.",
      buttonText: 'Create Free Account',
    },
    {
      id: 'e-commerce',
      image: `${STATIC_FILE_URL}/6ecffbf59835bf6b6130146d906e8da9.png`,
      title: 'Fast delivery with U.S. based fulfillment',
      description:
        'We take care of storage, kitting, shipping, and returns. Customers receive their orders in days, not weeks.',
      buttonText: 'Create Free Account',
    },
    {
      id: 'education',
      image: `${STATIC_FILE_URL}/00d92f6c712a9088c6be18145f587e33.png`,
      title: 'Up to 50% higher profits than dropshipping',
      description:
        "Your products will stand out from the crowd. With a brand, you can charge more and take home more profit. You'll never go back to the old way of dropshipping again.",
      buttonText: 'Create Free Account',
    },
  ],
};

export const PIETRA_SHOPIFY_PAGE_DATA: NewBrandsPageData = {
  hero: {
    title: "Maximize your Shopify store's profits.",
    subtitle: 'Shopify brands generate up to 50% higher profits with a Pietra membership.',
    bgColor:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), radial-gradient(2142.32% 108.06% at 38.63% -5.93%, #C5A827 0%, #6DAB0A 97.9%)',
    titleColor: '#000',
    preTitleImg: '/svg/pietra-shopify.svg',
    btnText: 'Create Pietra account',
    spotlightItems: [
      {
        image: `${STATIC_FILE_URL}/66da1b2875f9b968e7bc656b9944ccf7.png`,
        title: 'Lower cost of goods',
        description: "Post a project to Pietra's supplier network and watch factories compete for your business.",
      },
      {
        image: `${STATIC_FILE_URL}/f709c7e5e9aa15cc7540b75d6f5c4e0a.png`,
        title: 'Lower fulfillment fees',
        description:
          "Save 30% or more with Pietra's private 3PL designed for scaling brands across DTC, wholesale, and retail.",
      },
      {
        image: `${STATIC_FILE_URL}/697618d9980d86c639edae6d778eea38.png`,
        title: 'Higher sales revenue',
        description: 'Integrated sales and marketing tools to reach and engage customers across multiple channels.',
      },
    ],
  },
  highlightCards: {
    title: 'Ways to use Pietra',
    cards: [
      {
        img: '/svg/money-green.svg',
        title: 'Lower costs',
      },
      {
        img: '/svg/light-bulb-green.svg',
        title: 'Launch & test faster',
      },
      {
        img: '/svg/process-green.svg',
        title: 'Streamline operations',
      },
    ],
  },
  sectionsTitle: 'Trusted by 300,000+ entrepreneurs',
  sections: [
    {
      id: 'fulfillment',
      image: `${STATIC_FILE_URL}/5b2c73c4ff7a48ae1fa28e8da20f1f3e.png`,
      title: 'Lower costs with a vetted network of suppliers.',
      description:
        'Software to manage existing partners & access to 1300+ more vetted product, packaging, and merch factories to lower costs.',
      buttonText: 'Create Pietra account',
    },
    {
      id: 'e-commerce',
      image: `${STATIC_FILE_URL}/7f324886b99d58930595e6c08f287fb2.png`,
      title: 'Automatic order fulfillment & returns.',
      description:
        'A private 3PL designed for scaling brands across DTC, wholesale, and retail. Save 30% or more with no contracts, no minimums, and $1.50/order (unlimited picks).',
      buttonText: 'Create Pietra account',
    },
    {
      id: 'education',
      image: `${STATIC_FILE_URL}/e9125bf1d271803545c561004d611e88.png`,
      title: 'Increase sales with integrated marketing.',
      description:
        'Instantly list your products on Amazon, TikTok, and more. Reach new and existing customers by SMS and email.',
      buttonText: 'Create Pietra account',
    },
  ],
};

export const AVOID_TARIFFS: LandingPageData = {
  hero: {
    type: LandingPageHeroType.SPOTLIGHT,
    title: ['Avoid tariffs. Manufacture outside of China.'],
    subtitle:
      'We help companies find new factories, ensure they meet quality standards, coordinate transportation, and ultimately save them money.',
    button: {
      text: [{ text: 'Get started' }],
    },
    spotlightItems: [
      {
        image: `${STATIC_FILE_URL}/a567cea76f017280c16ecd0f0fa7b18d.png`,
        title: 'Pietra connects you to 50,000+ factories to help you find better suppliers, faster.',
      },
      {
        image: `${STATIC_FILE_URL}/25613c6e29b8096659da712a5c7fc011.png`,
        title: 'Pietra gives you the tools to move your supply chain to low-tariff markets.',
      },
      {
        image: `${STATIC_FILE_URL}/270a41e44e7df714d846ae1125abc379.png`,
        title: 'Pietra leverages AI to optimize sourcing, cut costs, and boost supply chain efficiency.',
      },
      {
        image: `${STATIC_FILE_URL}/ffa725ffc1e3e3619eda3a5a562cbb16.png`,
        title: "With Pietra's white-glove support, you can leave the logistics to us.",
      },
    ],
  },
  features: {
    title: 'Find new manufacturers & avoid tariffs.',
    features: [
      {
        image: `${STATIC_FILE_URL}/280dd5de2181eedc0f0fba0ecfcd29c9.png`,
        title: 'Quickly restructure your supply chain and save big.',
        description:
          "Don't waste time with agencies that will take month. We'll help you move out of tariff zones in days.",
        buttonText: 'Contact sales',
      },
      {
        image: `${STATIC_FILE_URL}/9cc595934bfb2b71672a34c780bb397a.png`,
        title: 'Talk to specialists and see options to get to 0% tariffs.',
        description:
          'Talk to a professional who can help you find factories, negotiate minimums, and start sampling fast. You can also use AI to scan through thousands of factories quickly.',
        buttonText: 'Contact sales',
      },
      {
        image: `${STATIC_FILE_URL}/fed024cbba14844b3aac8cdb54ae7d9a.png`,
        title: "Speak to a team of experts fast. We're here to help.",
        description:
          "Just like you, we're now obsessed with tariffs. Talk to a professional and join our daily workshops to learn more about all the ways to save your business.",
        buttonText: 'Contact sales',
      },
    ],
  },
};

export const HOME_PAGE_BRAND_VIDEO_LIST: BrandVideoData[] = [
  {
    logoWidth: 121,
    logoHeight: 16,
    logoAlt: 'homecourt',
    logoSrc: `${STATIC_FILE_URL}/83a6f4a1fbf20f58e3bbd2b762ef14e9.png`,
    videoPoster: `${STATIC_FILE_URL}/2b2b84d9157cfeaead1bb192b835dfec.png`,
    videoSrc: `${STATIC_FILE_URL}/b28acb8bf7f30f39cbdc87da240be622.mp4`,
  },
  {
    logoWidth: 55,
    logoHeight: 16,
    logoAlt: 'finn',
    logoSrc: `${STATIC_FILE_URL}/d66c21adf676f537138dc8c8bfbbb00a.png`,
    videoPoster: `${STATIC_FILE_URL}/9dc4db3b815cf374e293a0308fbff028.png`,
    videoSrc: `${STATIC_FILE_URL}/decc73adc420f9ffb255be53736d0967.mp4`,
  },
  {
    logoWidth: 68,
    logoHeight: 13,
    logoAlt: 'vacation',
    logoSrc: `${STATIC_FILE_URL}/0519cd92caee3c934d1fa3734e380d6c.png`,
    videoPoster: `${STATIC_FILE_URL}/6167c2e3ba24cc1cfdc43b875b57dc00.png`,
    videoSrc: `${STATIC_FILE_URL}/1c6f846c7edb98ed4d1105e348ec1dd0.mp4`,
  },
  {
    logoWidth: 67,
    logoHeight: 20,
    logoAlt: 'arrae',
    logoSrc: `${STATIC_FILE_URL}/0896cc7986b238044fab45052d44b9a2.png`,
    videoPoster: `${STATIC_FILE_URL}/5a91bde40a5a26c9c644e1a17da6750b.png`,
    videoSrc: `${STATIC_FILE_URL}/7b2df8cd56a3dfc286c47dee25f0e08e.mp4`,
  },
  {
    logoWidth: 73,
    logoHeight: 16,
    logoAlt: 'curie',
    logoSrc: `${STATIC_FILE_URL}/4daea92c8726199663fc80181784f9f1.png`,
    videoPoster: `${STATIC_FILE_URL}/8e6b932f9eebb2ec60490df2ee8bc64b.png`,
    videoSrc: `${STATIC_FILE_URL}/b54c1a440064bcc24ab4ff5ea42851e7.mp4`,
  },
  {
    logoWidth: 50,
    logoHeight: 24,
    logoAlt: 'bad-mouth',
    logoSrc: `${STATIC_FILE_URL}/93e183530089ebc01cb8004412abc564.png`,
    videoPoster: `${STATIC_FILE_URL}/fc16f61afa0d0dc86ba0c216293931f3.png`,
    videoSrc: `${STATIC_FILE_URL}/d3e921a54b61fbd60fa01fdaa35a2f26.mp4`,
  },
  {
    logoWidth: 119,
    logoHeight: 16,
    logoAlt: 'forvr-mood',
    logoSrc: `${STATIC_FILE_URL}/c57218ffdca6e621df0a11db3cdd4a5a.png`,
    videoPoster: `${STATIC_FILE_URL}/0d51c58b4e42c2fc9a60876cd400a05a.png`,
    videoSrc: `${STATIC_FILE_URL}/6b22104a182f763092a41ef8c73ab22a.mp4`,
  },
];
